import { render, staticRenderFns } from "./KanbanContainer.vue?vue&type=template&id=3885c8c0"
import script from "./KanbanContainer.vue?vue&type=script&lang=js"
export * from "./KanbanContainer.vue?vue&type=script&lang=js"
import style0 from "./KanbanContainer.vue?vue&type=style&index=0&id=3885c8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports